import * as React from "react"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"

const Seo = ({
   metaTitle = false,
   metaDescription = false,
   ogImage = false,
   type = 'website',
   modified = false
}) => {

   const location = useLocation()
   const uri = `https://rekord-fenster.com${location.pathname}`

   let ogImageUrl, ogImageW, ogImageH, ogImageType

   if (ogImage) {
      ogImageUrl = ogImage.sourceUrl
      ogImageW = ogImage.width
      ogImageH = ogImage.height
      ogImageType = ogImage.mimeType
   } else {
      ogImageUrl = 'https://rekord-fenster.com/og_image.jpeg'
      ogImageW = 1000
      ogImageH = 748
      ogImageType = "image/jpeg"
   }

   return (
      <Helmet
         htmlAttributes={{
            lang: 'de',
         }}
      >
         <title>{metaTitle || 'Rekord Fenster'}</title>
         <meta name="description" content={metaDescription || ''} />
         <meta property="og:locale" content="de_DE" />
         <meta property="og:title" content={metaTitle || 'Rekord Fenster'} />
         <meta property="og:description" content={metaDescription || ''} />
         <meta property="og:site_name" content="Rekord Fenster" />
         <meta property="og:type" content={type} />
         <meta property="og:url" content={uri} />
         <link rel="canonical" href={uri} />

         {type === 'article' && modified && (
            <meta property="article:modified_time" content={modified} />
         )}
         {type === 'article' && (
            <meta property="article:publisher" content="https://www.facebook.com/rekordfenster/" />
         )}

         <meta property="og:image" content={ogImageUrl} />
         <meta property="og:image:width" content={ogImageW} />
         <meta property="og:image:height" content={ogImageH} />
         <meta property="og:image:type" content={ogImageType} />

         <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
   )
}

export default Seo